import $ from 'jquery';
import Vars from '../../vars';
import Modal from '../../components/Modal';
import Request from '../../components/request';
import Utils from '../../components/utils';
import Validation from "../classes/Validation";

class Requisition {
    constructor(args) {
        let self = this;

        self._setArgs(args);
        self._init();
    }

    _elems = {
        $content : $(),
        $up      : $(),
        $down    : $(),
        $remove  : $()
    };

    _const = {
        entities : 'requests',
        entity   : 'request'
    };

    _args = {
        page : '',
        get  : ''
    };

    _state = {
        id       : 0,
        items    : {},
        item     : {},
        objects  : {},
        objectId : 0
    };

    _setArgs = (args) => {
        let self = this;

        self._args.page = args.page || self._args.page;
        self._args.get  = args.get  || self._args.get;
    };

    _bindElements = () => {
        let self = this;

        if (!self._elems.$content.length) self._elems.$content = $('.content');
        if (!self._elems.$content.length) return;

        self._elems.$up     = self._elems.$content.find('.js-profile-request-up');
        self._elems.$down   = self._elems.$content.find('.js-profile-request-down');
        self._elems.$remove = self._elems.$content.find('.js-profile-request-delete');
    };

    _bindUp = () => {
        let self = this;
        if (!self._elems.$up.length) return;

        self._elems.$up.unbind('click').on('click', function(e){
            e.preventDefault();

            let $link = $(this);
            const requestId = $link.data('id');

            if ($link.hasClass('upped')){
                return Request.send({
                    path: 	'/api/' + self._const.entities + '/' + requestId + '/up/0',
                    method: 'POST',

                    done: function(response) {
                        loader.decrease();

                        if (response.error) {
                            console.error(response.error);
                            return;
                        }

                        var url = new URL(window.location.href);
                        var get = url.hash.substring(9);

                        var object  = null;
                        var company = null;
                        var site    = null;
                        var widget  = null;



                        if (get.indexOf('object=') != -1){
                            object = get.substring(get.indexOf('object=') + 'object='.length);
                            if (object.indexOf('&') != -1) {
                                object = object.substring(0, object.indexOf('&'))
                            }
                        }
                        if (get.indexOf('company=') != -1){
                            company = get.substring(get.indexOf('company=') + 'company='.length);
                            if (company.indexOf('&') != -1) {
                                company = company.substring(0, company.indexOf('&'))
                            }
                        }
                        if (get.indexOf('site=') != -1){
                            site = get.substring(get.indexOf('site=') + 'site='.length);
                            if (site.indexOf('&') != -1) {
                                site = site.substring(0, site.indexOf('&'))
                            }
                        }
                        if (get.indexOf('widget=') != -1){
                            widget = get.substring(get.indexOf('widget=') + 'widget='.length);
                            if (widget.indexOf('&') != -1) {
                                widget = widget.substring(0, widget.indexOf('&'))
                            }
                        }

                        loader.increase();

                        Request.send({
                            queue: [
                                {
                                    path: '/api/requests' + get
                                },
                                {
                                    path: '/api/requests/options'
                                }
                            ],
                            done: function(response, extraResponse) {
                                loader.decrease();
                                Utils.scrollToTop();

                                self._state.items = response[self._const.entities];
                                self._state.item  = {};

                                let breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                                    crumbs : [
                                        {
                                            title : 'Главная',
                                            href  : '#'
                                        },
                                        {
                                            title : 'Мои заявки'
                                        }
                                    ],
                                    dropdown : null,
                                    activate : null
                                });

                                self._elems.$content.html(Utils.renderProfileTemplate(self._const.entities, {
                                    breadcrumbs                     : breadcrumbs,
                                    [self._const.entities]          : self._state.items,
                                    ['new_' + self._const.entities] : extraResponse.new,
                                    options                         : extraResponse.options,
                                    object_id                       : object,
                                    company_id                      : company,
                                    site_id                         : site,
                                    widget_id                       : widget,
                                }));

                                self._bindElements();
                                self._bindUI();
                            },
                        });
                    },
                });
            }
            new Modal({
                title: 		'Выделение заявки',
                content: 	Utils.renderProfileTemplate('info', {
                    message : 'Вы действительно хотите выделить эту заявку?',
                    buttons : {
                        one : {
                            class : 'confirm button--edit',
                            title : 'Да, выделить'
                        },
                        two : {
                            class : 'button--cancel',
                            title : 'Нет, отменить'
                        }
                    }
                }),
                confirm : function(args) {
                    let $modal = args.modal;

                    Request.send({
                        path: 	'/api/requests/' + requestId + '/up/1',
                        method: 'POST',

                        done: function(response) {
                            loader.decrease();

                            if (response.error) {
                                console.error(response.error);
                                return;
                            }
                            $modal.trigger('close');

                            var url = new URL(window.location.href);
                            var get = url.hash.substring(9);

                            var object  = null;
                            var company = null;
                            var site    = null;
                            var widget  = null;



                            if (get.indexOf('object=') != -1){
                                object = get.substring(get.indexOf('object=') + 'object='.length);
                                if (object.indexOf('&') != -1) {
                                    object = object.substring(0, object.indexOf('&'))
                                }
                            }
                            if (get.indexOf('company=') != -1){
                                company = get.substring(get.indexOf('company=') + 'company='.length);
                                if (company.indexOf('&') != -1) {
                                    company = company.substring(0, company.indexOf('&'))
                                }
                            }
                            if (get.indexOf('site=') != -1){
                                site = get.substring(get.indexOf('site=') + 'site='.length);
                                if (site.indexOf('&') != -1) {
                                    site = site.substring(0, site.indexOf('&'))
                                }
                            }
                            if (get.indexOf('widget=') != -1){
                                widget = get.substring(get.indexOf('widget=') + 'widget='.length);
                                if (widget.indexOf('&') != -1) {
                                    widget = widget.substring(0, widget.indexOf('&'))
                                }
                            }

                            loader.increase();
                            Request.send({
                                queue: [
                                    {
                                        path: '/api/requests' + get
                                    },
                                    {
                                        path: '/api/requests/options'
                                    }
                                ],
                                done: function(response, extraResponse) {
                                    loader.decrease();
                                    Utils.scrollToTop();

                                    self._state.items = response[self._const.entities];
                                    self._state.item  = {};

                                    let breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                                        crumbs : [
                                            {
                                                title : 'Главная',
                                                href  : '#'
                                            },
                                            {
                                                title : 'Мои заявки'
                                            }
                                        ],
                                        dropdown : null,
                                        activate : null
                                    });

                                    self._elems.$content.html(Utils.renderProfileTemplate(self._const.entities, {
                                        breadcrumbs                     : breadcrumbs,
                                        [self._const.entities]          : self._state.items,
                                        ['new_' + self._const.entities] : extraResponse.new,
                                        options                         : extraResponse.options,
                                        object_id                       : object,
                                        company_id                      : company,
                                        site_id                         : site,
                                        widget_id                       : widget,
                                    }));

                                    self._bindElements();
                                    self._bindUI();
                                },
                            });
                        },
                    });
                }
            });
        });
    };

    _bindDown = () => {
        let self = this;
        if (!self._elems.$down.length) return;

        self._elems.$down.unbind('click').on('click', function(e){
            e.preventDefault();

            let $link = $(this);
            const requestId = $link.data('id');

            if ($link.hasClass('downed')){
                return Request.send({
                    path: 	'/api/' + self._const.entities + '/' + requestId + '/down/0',
                    method: 'POST',

                    done: function(response) {
                        loader.decrease();

                        if (response.error) {
                            console.error(response.error);
                            return;
                        }

                        var url = new URL(window.location.href);
                        var get = url.hash.substring(9);

                        var object  = null;
                        var company = null;
                        var site    = null;
                        var widget  = null;



                        if (get.indexOf('object=') != -1){
                            object = get.substring(get.indexOf('object=') + 'object='.length);
                            if (object.indexOf('&') != -1) {
                                object = object.substring(0, object.indexOf('&'))
                            }
                        }
                        if (get.indexOf('company=') != -1){
                            company = get.substring(get.indexOf('company=') + 'company='.length);
                            if (company.indexOf('&') != -1) {
                                company = company.substring(0, company.indexOf('&'))
                            }
                        }
                        if (get.indexOf('site=') != -1){
                            site = get.substring(get.indexOf('site=') + 'site='.length);
                            if (site.indexOf('&') != -1) {
                                site = site.substring(0, site.indexOf('&'))
                            }
                        }
                        if (get.indexOf('widget=') != -1){
                            widget = get.substring(get.indexOf('widget=') + 'widget='.length);
                            if (widget.indexOf('&') != -1) {
                                widget = widget.substring(0, widget.indexOf('&'))
                            }
                        }

                        loader.increase();

                        Request.send({
                            queue: [
                                {
                                    path: '/api/requests' + get
                                },
                                {
                                    path: '/api/requests/options'
                                }
                            ],
                            done: function(response, extraResponse) {
                                loader.decrease();
                                Utils.scrollToTop();

                                self._state.items = response[self._const.entities];
                                self._state.item  = {};

                                let breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                                    crumbs : [
                                        {
                                            title : 'Главная',
                                            href  : '#'
                                        },
                                        {
                                            title : 'Мои заявки'
                                        }
                                    ],
                                    dropdown : null,
                                    activate : null
                                });

                                self._elems.$content.html(Utils.renderProfileTemplate(self._const.entities, {
                                    breadcrumbs                     : breadcrumbs,
                                    [self._const.entities]          : self._state.items,
                                    ['new_' + self._const.entities] : extraResponse.new,
                                    options                         : extraResponse.options,
                                    object_id                       : object,
                                    company_id                      : company,
                                    site_id                         : site,
                                    widget_id                       : widget,
                                }));

                                self._bindElements();
                                self._bindUI();
                            },
                        });
                    },
                });
            }
            new Modal({
                title: 		'Скрытие заявки',
                content: 	Utils.renderProfileTemplate('info', {
                    message : 'Вы действительно хотите скрыть эту заявку?<br />Скрытые заявки перемещаются в конец списка.',
                    buttons : {
                        one : {
                            class : 'confirm button--edit',
                            title : 'Да, скрыть'
                        },
                        two : {
                            class : 'button--cancel',
                            title : 'Нет, отменить'
                        }
                    }
                }),
                confirm : function(args) {
                    let $modal = args.modal;

                    Request.send({
                        path: 	'/api/requests/' + requestId + '/down/1',
                        method: 'POST',

                        done: function(response) {
                            loader.decrease();

                            if (response.error) {
                                console.error(response.error);
                                return;
                            }
                            $modal.trigger('close');

                            var url = new URL(window.location.href);
                            var get = url.hash.substring(9);

                            var object  = null;
                            var company = null;
                            var site    = null;
                            var widget  = null;



                            if (get.indexOf('object=') != -1){
                                object = get.substring(get.indexOf('object=') + 'object='.length);
                                if (object.indexOf('&') != -1) {
                                    object = object.substring(0, object.indexOf('&'))
                                }
                            }
                            if (get.indexOf('company=') != -1){
                                company = get.substring(get.indexOf('company=') + 'company='.length);
                                if (company.indexOf('&') != -1) {
                                    company = company.substring(0, company.indexOf('&'))
                                }
                            }
                            if (get.indexOf('site=') != -1){
                                site = get.substring(get.indexOf('site=') + 'site='.length);
                                if (site.indexOf('&') != -1) {
                                    site = site.substring(0, site.indexOf('&'))
                                }
                            }
                            if (get.indexOf('widget=') != -1){
                                widget = get.substring(get.indexOf('widget=') + 'widget='.length);
                                if (widget.indexOf('&') != -1) {
                                    widget = widget.substring(0, widget.indexOf('&'))
                                }
                            }

                            loader.increase();
                            Request.send({
                                queue: [
                                    {
                                        path: '/api/requests' + get
                                    },
                                    {
                                        path: '/api/requests/options'
                                    }
                                ],
                                done: function(response, extraResponse) {
                                    loader.decrease();
                                    Utils.scrollToTop();

                                    self._state.items = response[self._const.entities];
                                    self._state.item  = {};

                                    let breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                                        crumbs : [
                                            {
                                                title : 'Главная',
                                                href  : '#'
                                            },
                                            {
                                                title : 'Мои заявки'
                                            }
                                        ],
                                        dropdown : null,
                                        activate : null
                                    });

                                    self._elems.$content.html(Utils.renderProfileTemplate(self._const.entities, {
                                        breadcrumbs                     : breadcrumbs,
                                        [self._const.entities]          : self._state.items,
                                        ['new_' + self._const.entities] : extraResponse.new,
                                        options                         : extraResponse.options,
                                        object_id                       : object,
                                        company_id                      : company,
                                        site_id                         : site,
                                        widget_id                       : widget,
                                    }));

                                    self._bindElements();
                                    self._bindUI();
                                },
                            });
                        },
                    });
                }
            });
        });
    };

    _bindRemove = () => {
        let self = this;
        if (!self._elems.$remove.length) return;

        self._elems.$remove.unbind('click').on('click', function(e) {
            e.preventDefault();

            let $link = $(this);
            const requestId = $link.data('id');

            new Modal({
                title: 		'Удаление заявки',
                content: 	Utils.renderProfileTemplate('info', {
                    message : 'Вы действительно хотите удалить эту заявку',
                    buttons : {
                        one : {
                            class : 'confirm button--remove',
                            title : 'Да, удалить'
                        },
                        two : {
                            class : 'button--cancel',
                            title : 'Нет, отменить'
                        }
                    }
                }),
                confirm : function(args) {
                    let $modal = args.modal;

                    Request.send({
                        path: '/api/requests/' + requestId + '/delete',
                        method: 'POST',

                        done: function (response) {
                            loader.decrease();

                            if (response.error) {
                                console.error(response.error);
                                return;
                            }

                            $modal.trigger('close');

                            var url = new URL(window.location.href);
                            var get = url.hash.substring(9);

                            var object  = null;
                            var company = null;
                            var site    = null;
                            var widget  = null;



                            if (get.indexOf('object=') != -1){
                                object = get.substring(get.indexOf('object=') + 'object='.length);
                                if (object.indexOf('&') != -1) {
                                    object = object.substring(0, object.indexOf('&'))
                                }
                            }
                            if (get.indexOf('company=') != -1){
                                company = get.substring(get.indexOf('company=') + 'company='.length);
                                if (company.indexOf('&') != -1) {
                                    company = company.substring(0, company.indexOf('&'))
                                }
                            }
                            if (get.indexOf('site=') != -1){
                                site = get.substring(get.indexOf('site=') + 'site='.length);
                                if (site.indexOf('&') != -1) {
                                    site = site.substring(0, site.indexOf('&'))
                                }
                            }
                            if (get.indexOf('widget=') != -1){
                                widget = get.substring(get.indexOf('widget=') + 'widget='.length);
                                if (widget.indexOf('&') != -1) {
                                    widget = widget.substring(0, widget.indexOf('&'))
                                }
                            }

                            loader.increase();
                            Request.send({
                                queue: [
                                    {
                                        path: '/api/requests' + get
                                    },
                                    {
                                        path: '/api/requests/options'
                                    }
                                ],
                                done: function(response, extraResponse) {
                                    loader.decrease();
                                    Utils.scrollToTop();

                                    self._state.items = response[self._const.entities];
                                    self._state.item  = {};

                                    let breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                                        crumbs : [
                                            {
                                                title : 'Главная',
                                                href  : '#'
                                            },
                                            {
                                                title : 'Мои заявки'
                                            }
                                        ],
                                        dropdown : null,
                                        activate : null
                                    });

                                    self._elems.$content.html(Utils.renderProfileTemplate(self._const.entities, {
                                        breadcrumbs                     : breadcrumbs,
                                        [self._const.entities]          : self._state.items,
                                        ['new_' + self._const.entities] : extraResponse.new,
                                        options                         : extraResponse.options,
                                        object_id                       : object,
                                        company_id                      : company,
                                        site_id                         : site,
                                        widget_id                       : widget,
                                    }));

                                    self._bindElements();
                                    self._bindUI();
                                },
                            });
                        }
                    });
                }
            });
        });
    };

    _bindUI = () => {
        let self = this;

        self._bindUp();
        self._bindDown();
        self._bindRemove();

        self._elems.$content.find('select[name="request[object]"]').change(function() {
            let params = window.location.hash.indexOf('?') !== -1 ? window.location.hash.substring(window.location.hash.indexOf('?') + 1) : '';
            if (params.indexOf('object=') != -1) {
                params = params.substring(0, params.indexOf('object=') + 1, params.indexOf('object=') + 'object='.length + 1);
            }
            window.location.href = '/profile#requests?object=' + $(this).val() + '&' + params;
        });

        self._elems.$content.find('select[name="request[company]"]').change(function(){
            let params = window.location.hash.indexOf('?') !== -1 ? window.location.hash.substring(window.location.hash.indexOf('?') + 1) : '';
            if (params.indexOf('company=') != -1) {
                params = params.substring(0, params.indexOf('company=') + 1, params.indexOf('company=') + 'company='.length + 1);
            }

            window.location.href = '/profile#requests?company=' + $(this).val() + '&' + params;
        });

        self._elems.$content.find('select[name="request[site]"]').change(function(){
            let params = window.location.hash.indexOf('?') !== -1 ? window.location.hash.substring(window.location.hash.indexOf('?') + 1) : '';
            if (params.indexOf('site=') != -1) {
                params = params.substring(0, params.indexOf('site=') + 1, params.indexOf('site=') + 'site='.length + 1);
            }

            window.location.href = '/profile#requests?site=' + $(this).val() + '&' + params;
        });

        self._elems.$content.find('select[name="request[widget]"]').change(function(){
            let params = window.location.hash.indexOf('?') !== -1 ? window.location.hash.substring(window.location.hash.indexOf('?') + 1) : '';
            if (params.indexOf('widget=') != -1) {
                params = params.substring(0, params.indexOf('widget=') + 1, params.indexOf('widget=') + 'widget='.length + 1);
            }

            window.location.href = '/profile#requests?widget=' + $(this).val() + '&' + params;
        });
    };

    _list = () => {
        let self = this;

        let url = new URL(window.location.href);
        let get = url.hash.substring(9);

        let object  = null;
        let company = null;
        let site    = null;
        let widget  = null;

        if (get.indexOf('object=') != -1){
            object = get.substring(get.indexOf('object=') + 'object='.length);
            if (object.indexOf('&') != -1) {
                object = object.substring(0, object.indexOf('&'))
            }
        }
        if (get.indexOf('company=') != -1){
            company = get.substring(get.indexOf('company=') + 'company='.length);
            if (company.indexOf('&') != -1) {
                company = company.substring(0, company.indexOf('&'))
            }
        }
        if (get.indexOf('site=') != -1){
            site = get.substring(get.indexOf('site=') + 'site='.length);
            if (site.indexOf('&') != -1) {
                site = site.substring(0, site.indexOf('&'))
            }
        }
        if (get.indexOf('widget=') != -1){
            widget = get.substring(get.indexOf('widget=') + 'widget='.length);
            if (widget.indexOf('&') != -1) {
                widget = widget.substring(0, widget.indexOf('&'))
            }
        }

        loader.increase();
        Request.send({
            queue : [
                {
                    path: '/api/' + self._const.entities + get
                },
                {
                    path: '/api/' + self._const.entities + '/options',
                }
            ],
            done: function (response, extraResponse) {
                loader.decrease();
                Utils.scrollToTop();

                self._state.items = response[self._const.entities];
                self._state.item  = {};

                let breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                    crumbs : [
                        {
                            title : 'Главная',
                            href  : '#'
                        },
                        {
                            title : 'Мои заявки'
                        }
                    ],
                    dropdown : null,
                    activate : null
                });

                self._elems.$content.html(Utils.renderProfileTemplate(self._const.entities, {
                    breadcrumbs                     : breadcrumbs,
                    [self._const.entities]          : self._state.items,
                    ['new_' + self._const.entities] : extraResponse.new,
                    options                         : extraResponse.options,
                    object_id                       : object,
                    company_id                      : company,
                    site_id                         : site,
                    widget_id                       : widget,
                }));

                self._bindElements();
                self._bindUI();
            }
        });
    };

    _init = () => {
        let self = this;
        self._bindElements();
        if (!self._elems.$content.length) return;

        if (self._args.page === Vars.page.list) {
            self._list();
        }
    };
}

export default Requisition;